import React, { Component } from 'react';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import ProjectSelect from '../Projects/ProjectSelect'
import GroupSelectBlock from '../Projects/GroupSelectBlock'
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import authStore from '../../Auth/AuthStore';
import MainStore from '../../../MainStore';
import { HubConnectionBuilder } from '@aspnet/signalr';
import SuggestionsStore from './SuggestionsStore';
import { DragDropContext } from 'react-beautiful-dnd'
import UserSelect from '../Users/UserSelect';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/AddCircleOutline';
import MenuIcon from '@mui/icons-material/Menu';
import IconButton from '@mui/material/IconButton';
import { observer } from 'mobx-react';
import Popover from '@mui/material/Popover';
import SuggestionsColumn from './SuggestionsColumn';
import SuggestionDialog from './SuggestionDialog';
import SuggestionFlagDialog from './SuggestionFlagDialog';
import '../Kanban/kanban.css';
import './suggestions.css';
import SuggestionCategorySelect from './SuggestionCategorySelect';
import TextSearchBlock from '../Common/TextSearchBlock';

const SuggestionsBoard = observer(class SuggestionsBoard extends Component {
    columns = [
        { name: 'Предложение', id: 'b7d01d88-8e96-47f1-959b-81189e71ed57', isShow: true },
        { name: 'Обсуждение', id: '927daba8-fa6c-4858-be78-639524ecd395', isShow: true },
        { name: 'Реализация', id: '09a4ddd1-dfb7-4851-accb-b7da22a267b4', isShow: true },
        { name: 'Тестирование', id: '9e5fdcd5-9eca-4d55-8633-335763dc1180', isShow: true },
        { name: 'Запуск', id: '54bf825c-e14b-41bc-bf3e-6e53053d4bc6', isShow: true },
        { name: 'Выполнено', id: '64fdbe99-7ef0-44de-b9a5-788efd7d64b7', isShow: true, isCollapsable: true },
    ];
    constructor(props) {
        super(props);


        this.state = {
            suggestionCategoryFilterId: (localStorage.getItem('suggestionCategoryFilterId') !== 'null' && !!localStorage.getItem('suggestionCategoryFilterId')) ? localStorage.getItem('suggestionCategoryFilterId') : '',
            suggestionCategoryFilterName: (localStorage.getItem('suggestionCategoryFilterName') !== 'null' && !!localStorage.getItem('suggestionCategoryFilterName')) ? localStorage.getItem('suggestionCategoryFilterName') : '',
            searchType: 0,
            searchStr: ''
        };

        this.handleOnDragEnd = this.handleOnDragEnd.bind(this);
        this.load = this.load.bind(this);
        this.startSearch = this.startSearch.bind(this);
        this.handleCardAdd = this.handleCardAdd.bind(this);
        this.onLookupFilterChange = this.onLookupFilterChange.bind(this);
        
        const hubConnection = new HubConnectionBuilder()
            .withUrl("/hub")
            .build();

        hubConnection.on('suggestionUpdated', (senderId, work) => {
            if (senderId !== authStore.getUserId) {

            }
        });

        hubConnection.onclose((error) => { console.log('socket error'); console.log(error); hubConnection.start(); });

        hubConnection.start();
    }

    componentDidMount() {
        if (!authStore.isAuth) {
            authStore.openLogin();
            return;
        }
        else this.load();

        var token = localStorage.getItem("token");
        var url = new URL(document.location.href);
        var workNumber = url.searchParams.get("suggestion");
        if (workNumber) {
            MainStore.setMaskVisible();
            fetch('api/Suggestion/GetByNumber?number=' + encodeURIComponent(workNumber), {
                method: 'GET',
                body: null,
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            }).then(function (res) {
                if (res.status === 401) {
                }
                else {
                    res.json().then((result) => {
                        MainStore.setMaskUnvisible();
                        SuggestionsStore.openSuggestionDialog(result);
                    }).catch((err) => console.log(err));
                }
            });
        }
    }

    load() {
        var token = localStorage.getItem("token");
        //MainStore.setMaskVisible();
        fetch('api/Suggestion/Load', {
            method: 'POST',
            body: JSON.stringify({ searchString: encodeURIComponent(this.state.searchStr), categoryId: this.state.suggestionCategoryFilterId, searchType: this.state.searchType }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            },
        }).then(function (res) {
            if (res.status === 401) {
                authStore.openLogin();
                MainStore.setMaskUnvisible();
            }
            else {
                res.json().then((result) => {
                    //scope.setState({ works: result });
                    SuggestionsStore.setSuggestions(result);
                    MainStore.setMaskUnvisible();
                }).catch((err) => console.log(err));
            }
        });
    }

    startSearch(value) {
        this.setState({searchStr: value}, this.load);
    }

    sort(a, b) {
        var res = b.rating - a.rating;
        return res === 0 ? a.position - b.position : res;
    }

    //this is called when a Kanban card dropped over a column (called by card)
    handleOnDragEnd(e) {
        const { destination, source } = e;
        if (!destination) {
            return
        }

        if (
            destination.droppableId === source.droppableId &&
            destination.index === source.index
        ) {
            return
        }

        MainStore.setMaskVisible();
        const works = SuggestionsStore.getSuggestions.slice(0);
        var work = works[works.findIndex(s => s.id === e.draggableId)];
        var newStatusId = destination.droppableId;

        if (newStatusId.indexOf("project") > -1) {
            newStatusId = newStatusId.substring(0, 36);
            console.log(newStatusId);
        }

        var columnWorks = works.filter(w => w.statusId === newStatusId).sort(this.sort);
        var dragSrcPosition = 0;
        if (columnWorks.length !== 0) {
            dragSrcPosition = columnWorks[e.destination.index >= columnWorks.length ? columnWorks.length - 1 : e.destination.index].position;
        }

        var selectedWorks = works.filter(w => w.isSelected).sort(this.sort);
        if (selectedWorks.length === 0) selectedWorks = [work];

        if (work.position < dragSrcPosition) dragSrcPosition = dragSrcPosition + 1;

        if (work.position !== dragSrcPosition) {
            works.forEach(w => {
                if (w.position >= dragSrcPosition && w.id !== work.id) {
                    w.position = w.position + selectedWorks.length;
                }
            })
        }
        else {
            dragSrcPosition = dragSrcPosition - 1;
            works.forEach(w => {
                if (w.position >= dragSrcPosition && w.id !== work.id) {
                    w.position = w.position + selectedWorks.length;
                }
            })
        }

        var token = localStorage.getItem("token");
        for (var i = 0; i < selectedWorks.length; i++) {
            selectedWorks[i].statusId = newStatusId;
            selectedWorks[i].position = dragSrcPosition + (selectedWorks.length - 1 - i);

            fetch('api/Suggestion', {
                method: 'POST',
                body: JSON.stringify(selectedWorks[i]),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token
                }
            }).then(function (res) {
                if (res.status === 401) {
                    authStore.openLogin();
                    MainStore.setMaskUnvisible();
                }
                else {
                    res.json().then((result) => {
                        //var works = scope.state.works;

                        //var index = works.findIndex(w => w.id === result.id);
                        //works[index] = result;

                        //works = works.sort(this.sort);

                        MainStore.setMaskUnvisible();
                        SuggestionsStore.updateSuggestion(result);
                        //scope.setState({ works: works, isWorkDialogOpen: false });
                    }).catch((err) => console.log(err));
                }
            });
        }
        //works.find((w) => { return w.number === work.number; }).statusId = newStatusId;
        //this.setState({ works: works});
    }

    uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    handleCardAdd() {
        SuggestionsStore.openSuggestionDialog({
            caption: this.state.searchStr,
            sessionId: this.uuidv4(),
            text: '<p><strong>Что?</strong></p><ol><li>&nbsp;</li></ol><p><strong>Зачем?</strong></p><ol><li>&nbsp;</li></ol><p><strong>Кто?</strong></p><ul><li>&nbsp;</li></ul><p><strong>Как?</strong></p><ul><li>&nbsp;</li></ul><p><strong>План:</strong></p><ul class="todo-list"><li><label class="todo-list__label"><input type="checkbox" disabled="disabled"></label></li></ul>',
            rating: 0
        });
    }

    handleCardOpen(work) {
        SuggestionsStore.openSuggestionDialog(work);
    }

    handleClose() {
        this.setState({ isWorkDialogOpen: false });
    }

    handleChange = name => evt => {
        this.setState({ [name]: evt.target.value });
    }

    onLookupFilterChange = name => obj => {
        if (obj) {
            this.setState({ [name + "Id"]: obj.id, [name + "Name"]: obj.name }, this.load );
            localStorage.setItem(name + "Id", obj.id);
            localStorage.setItem(name + "Name", obj.name);
        }
        else {
            this.setState({ [name + "Id"]: null, [name + "Name"]: '' }, this.load);
            localStorage.setItem(name + "Id", '');
            localStorage.setItem(name + "Name", '');
        }
    }

    /*openProjectDrawer() {
        MainStore.setIsProjectDrawerVisible(true);
    }*/

    render() {
        return (
            <div className="kanban-columns-wrapper">
                <div className="quick-filter-panel clearfix">
                    <div className="add-button-block">
                        <IconButton onClick={this.handleCardAdd} size="large"><AddIcon style={{ fill: "red" }} /></IconButton>
                    </div>
                    <div className="quick-filter-item">
                        <SuggestionCategorySelect label="Категория" name={this.state.suggestionCategoryFilterName} handleSelect={this.onLookupFilterChange('suggestionCategoryFilter')} />
                    </div>
                    <div className="quick-filter-item big">
                        <TextSearchBlock searchStr={this.state.searchStr} startSearch={this.startSearch} handleChange={this.handleChange}/>
                    </div>
                </div>
                <div style={{ display: "flex" }}>
                    <DragDropContext onDragEnd={this.handleOnDragEnd}>
                        {this.columns.filter(c => !!c.isShow).map((column) => {
                            return (
                                <SuggestionsColumn
                                    name={column.name}
                                    id={column.id}
                                    works={SuggestionsStore.getSuggestions.filter((w) => { return (!column.isMultiply && w.statusId === column.id) || (column.isMultiply && column.id.findIndex(i => i.value === w.statusId) > -1) }).sort(this.sort)}
                                    //onWorkUpdate={this.handleWorkFlagUpdate}
                                    isCollapseColumn={column.isCollapsable}
                                    isGroupable={column.isGroupable}
                                    isMultiply={column.isMultiply}
                                    key={column.id}
                                    onCardOpen={this.handleCardOpen}
                                    onCtrlCardClick={this.handleCtrlCardClick}
                                />
                            );
                        })}
                    </DragDropContext>
                </div>
                <SuggestionDialog />
                <SuggestionFlagDialog />
            </div>
        );
    }
});

export default SuggestionsBoard;